<template>
<div>

  <div class="content content-boxed">
    <!-- Information du profile -->
    <div class="row">
      <div class="col-xs-12">

        <h3 class="font-w300 push-10">{{ labelTitleSection[actualLanguage] }}</h3>
        <div class="block block-bordered">
          <div class="block block-themed">
            <div class="block-header bg-primary-dark">
                  <ul  class="block-options">
                      <li v-if="flagDisplayBanner===0">
                          <button type="button" @click="toggleDisplayBanner()"><i class="fa fa-angle-double-down fa-2x"></i></button>
                      </li>
                      <li v-if="flagDisplayBanner">
                          <button  type="button" @click="toggleDisplayBanner()"><i class="fa fa-angle-double-up fa-2x"></i></button>
                      </li>
                  </ul>
              <h2 class="block-title" @click="toggleDisplayBanner()">{{labelTitleBanner[actualLanguage]}}</h2>
            </div>

            <div v-if="flagDisplayBanner" class="block-content">

              <div class="row">
                <div class="col-xs-12">
                    <!-- Static Labels -->
                    <div class="block">
                        <h2 class="block-title" @click="toggleDisplayBanner()">Sélection de l'organisation</h2>

                        <div class="col-xs-12 col-sm-12 push">
                          <select class="form-control" @change="getTransactionHistory()" v-model="selectedOrganizationId" size="1">
                              <option v-for="organization in organizationList" :value="organization.OrganizationId">{{organization.OrganizationName}}       [{{organization.OrganizationId}}]</option>
                          </select>
                        </div>

                        <div v-if="flagDisplaySectionTransactions" class="col-xs-12 col-md-12">

                            <div v-for ="(transaction,index) in transactions" class="block block-bordered">
                              <div class="block-header bg-gray-lighter">
                                  <ul class="block-options">
                                      <li>
                                          <button type="button" @click="toggleDisplayTransaction(index)"><i class="fa fa-dollar"></i></button>
                                      </li>
                                  </ul>
                                  <h3 class="block-title" @click="toggleDisplayTransaction(index)">{{transaction.subscription}}:{{transaction.timestamp}}</h3>
                              </div>
                              <div v-if="transactionOpenFlag[index]" class="block-content">

                                  <div class="table-responsive push-50">
                                      <table class="table table-bordered table-hover">
                                          <thead>
                                              <tr>
                                                  <th class="text-center" style="width: 50px;"></th>
                                                  <th>{{textLabelProduct[[actualLanguage]]}}</th>
                                                  <th class="text-center" style="width: 100px;">{{InvoiceQuantity[actualLanguage]}}</th>
                                                  <th class="text-right" style="width: 120px;">{{InvoiceUnitPrice[actualLanguage]}}</th>
                                                  <th class="text-right" style="width: 120px;">{{InvoicePrice[actualLanguage]}}</th>
                                              </tr>
                                          </thead>
                                          <tbody>
                                              <tr v-for ="(transactionLine,index) in transaction.detailLines">
                                                  <td class="text-center">{{index+1}}</td>
                                                  <td>
                                                      <p class="font-w600 push-10">{{transactionLine.description[actualLanguage]}}</p>
                                                  </td>
                                                  <td class="text-center"><span class="badge badge-primary">{{transactionLine.quantity}}</span></td>
                                                  <td class="text-right">$ {{transactionLine.unitPrice}}</td>
                                                  <td class="text-right">$ {{transactionLine.unitPrice*transactionLine.quantity}}</td>
                                              </tr>


                                              <tr>
                                                  <td colspan="4" class="font-w600 text-right">{{InvoiceSubTotal[actualLanguage]}}</td>
                                                  <td class="text-right">$ {{transaction.subTotal}}</td>
                                              </tr>
                                              <tr v-if="transaction.tps > 0">
                                                  <td colspan="4" class="font-w600 text-right">TPS (5%)</td>
                                                  <td class="text-right">$ {{transaction.tps}}</td>
                                              </tr>
                                              <tr v-if="transaction.tvq > 0">
                                                  <td colspan="4" class="font-w600 text-right">TVQ (9.975%)</td>
                                                  <td class="text-right">$ {{transaction.tvq}}</td>
                                              </tr>

                                              <tr v-for="(taxLine, index2) in transaction.taxesList">
                                                  <td colspan="4" class="font-w600 text-right">{{taxLine.Label[actualLanguage]}}</td>
                                                  <td class="text-right">$ {{taxLine.Amount}}</td>
                                              </tr>

                                              <tr class="active">
                                                  <td colspan="4" class="font-w700 text-uppercase text-right">Total</td>
                                                  <td class="font-w700 text-right">$ {{transaction.total}}</td>
                                              </tr>
                                          </tbody>
                                      </table>

                                      <div class="col-sm-12 col-lg-12 align-left push">
                                          <h6 class="block-title text-left" >{{CardInfoPaidBy[actualLanguage]}}{{transaction.cardData.CardType}}</h6>
                                          <h6 class="block-title text-left" >{{CardInfoLast4[actualLanguage]}}{{transaction.cardData.CardLast4}}</h6>
                                      </div>


                                      <div class="col-sm-12 col-lg-12 align-right push">
                                        <h2 class="block-title push">Information paiement</h2>

                                        <div class="col-xs-12 col-sm-12 push">
                                          <h5 class="push">Information facturation manuelle</h5>

                                          <div class="col-xs-12 col-sm-6">
                                              <h6>Numéro de facture Quickbook</h6>
                                              <input v-model="transaction.manualInvoice.referenceNumber" class="form-control align-center" type="test"  placeholder="">
                                          </div>

                                          <div class="col-xs-12 col-sm-3">
                                              <h6>Facture transmise au client</h6>
                                              <label class="css-input switch switch-success">
                                              <input type="checkbox" checked v-model="transaction.manualInvoice.transmitted">
                                              <span></span>
                                              </label>
                                          </div>

                                          <div class="col-xs-12 col-sm-3 push">
                                              <h6>Paiement reçu</h6>
                                              <label class="css-input switch switch-success">
                                              <input type="checkbox" checked v-model="transaction.paymentReceived">
                                              <span></span>
                                              </label>
                                          </div>

                                          <div class="col-xs-12 col-sm-12 align-center">
                                            <button  type="button" @click="saveTransactionPaymentInformation(index)" class="btn btn-xs align-center" name="buttonAddPlanItem">
                                            <spinner size="small" v-if="transactionIsSaving"></spinner>
                                            <span v-else><i class="fa fa-floppy-o fa-1x push-5-r "></i>Enregistrer les informations de paiement </span></button> 
                                          </div> 

                                        </div>
                                      </div>


                                      <div class="col-sm-12 col-lg-12 align-right push">
                                          <h2 class="block-title push">Comissions integrateurs</h2>
                                          <div v-for ="(commission,index) in transaction.integratorCommissions" class="col-sm-12 col-lg-12 align-right push">
                                            {{commission}}
                                          </div>
                                          
                                      </div>


                                  </div>
                            </div>

                        </div>
                    <!-- END Static Labels -->
                    </div>
                </div>

              </div>
            </div>
          </div>
        </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>


<script>

import Spinner from '@/components/Spinner'

import {mapState, mapActions, mapGetters} from 'vuex'

export default {
  name: 'GroupIndex',
  props: ['inputData'],
  data() {
    return {
      flagDisplayBanner : 0,
      profileIsSaving : false,
      actualLanguage : "FR",
      labelTitleSection: {FR: "Historique de transaction d'organisation", EN: 'Organization transaction history'},
      labelTitleBanner: {FR: 'Historique de transaction', EN: 'Transaction history'},
      organizationList:[],
      selectedOrganizationId:'',
      flagDisplaySectionTransactions : true,
      transactions : [],
      transactionOpenFlag : [],
      transactionIsSaving:false,

      transactionIsReading : false,

      textLabelProduct:{FR: "Produit", EN: 'Product'},
      textLabelLastPaimentDate:{FR: "Date du précédent prélèvement : ", EN: 'Previous payment date:'},
      textLabelNextPaimentDate:{FR: "Date du prochain prélèvement : ", EN: 'Next payment date:'},
      InvoiceText: {FR: "Facture: ", EN: 'Invoice: '},
      InvoiceTitle: {FR: "SERVICE PLATEFORME ADMINISTRATEUR", EN: 'MANAGER PLATFORM CHARGE'},
      InvoiceCustomer: {FR: "CLIENT: ", EN: 'CUSTOMER: '},
      InvoicePaidBy: {FR: "PAYÉ AVEC: ", EN: 'PAID BY: '},
      InvoiceQuantity: {FR: "Quantité", EN: 'Quantity'},
      InvoiceUnitPrice: {FR: "Prix unitaire", EN: 'Unit price'},
      InvoicePrice: {FR: "Prix", EN: 'Price'},
      InvoiceSubTotal: {FR: "Sous total", EN: 'Sub total'},
      CardInfoPaidBy: {FR: "Payé par:", EN: 'Paid by:'},
      CardInfoLast4: {FR: "Finissant par:", EN: 'Last digits:'},

    }
  },
  components: {
    Spinner
  },
  computed: {
    ...mapState('sessionStore', ['userEmail','profileData']),
  },

  methods: {
    ...mapActions('overlayStore', ['showModal']),

   toggleDisplayBanner(){
      this.flagDisplayBanner = ~this.flagDisplayBanner
    },

    toggleDisplayTransaction(index){
      this.flagDisplaySectionTransactions=0
      this.transactionOpenFlag[index]=~this.transactionOpenFlag[index]
      this.flagDisplaySectionTransactions=-1
    },

    getOrganizationList(){
        var requestData = {'postAction':'ReadOrganizationList',
                          'organizationId':'None'}
        this.profileIsSaving = true
        this.$store.dispatch('sessionStore/postOrganization', requestData)
            .then((response) => {
            if(response.data.Code=='OK'){
                this.organizationList = response.data.OrganizationsList
                }
                else{
                  window.alert(response.data.PromptMessage[this.actualLanguage])
                  }
            })
    },


    getTransactionHistory(){
      
      var requestData = { 'postAction':'ReadOrganizationTransactionHistory',
                          'organizationId':this.selectedOrganizationId,
                          }

      this.transactionIsReading = true
      this.$store.dispatch('sessionStore/postOrganization', requestData)
        .then((response) => {
          if(response.data.Code=='OK'){
           //console.log('transaction history')
            //console.log(response.data)
            this.transactions = response.data.TransactionHistory
            this.transactionOpenFlag = []
            for(var m = 0;m < this.transactions.length;m++){
              this.transactionOpenFlag.push(0)
              if(parseFloat(this.transactions[m].subTotal) < 0){this.transactions[m].subTotal = "0"}
              if(parseFloat(this.transactions[m].tps) < 0){this.transactions[m].tps = "0"}
              if(parseFloat(this.transactions[m].tvq) < 0){this.transactions[m].tvq = "0"}
              if(parseFloat(this.transactions[m].total) < 0){this.transactions[m].total = "0"}

              for(var n = 0;n < this.transactions[m].taxesList.length;n++){
                if(parseFloat(this.transactions[m].taxesList[n].Amount) < 0){this.transactions[m].taxesList[n].Amount = "0"}
                }
              
              }
            }
            else{
              //console.log(response)
               window.alert(response.data.PromptMessage[this.actualLanguage] )
            }
        })
        this.transactionIsReading = false
    },

    saveTransactionPaymentInformation(index){
        var requestData = {'postAction':'SaveTransactionPaymentInfo',
                           'organizationId':this.selectedOrganizationId,
                          'transaction':this.transactions[index]}
        this.transactionIsSaving = true
        console.log(requestData)
        this.$store.dispatch('sessionStore/postOrganization', requestData)
            .then((response) => {
              console.log(response)
            if(response.data.Code=='OK'){
                this.transactionIsSaving = false
                }
                else{
                  this.transactionIsSaving = false
                  window.alert(response.data.PromptMessage[this.actualLanguage])
                  }
            })
    },





    returnToMyServicePlan(){
      this.planTransactionData.transactionStatusCode = '000'
      this.flagDisplayPlan = 0
      window.scrollTo(0, 0)
    },







    },

  mounted() {
    //this.getDeviceData()
    //window.location.reload()
    this.getOrganizationList()


    if(localStorage.language){this.actualLanguage =  localStorage.language}
    else{this.actualLanguage = 'FR'}
  }
}
</script>





// WEBPACK FOOTER //
// ViewEditManualInvoice.vue?44c17b02